import { splitKeywords } from "./components/gabarito-utils";
import type { Profile } from "./types";

const unique = (values: string[]) => {
  const result: string[] = [];

  values.forEach((value) => {
    const cleanValue = value.trim();
    if (
      cleanValue &&
      !result.some((item) => item.toLowerCase() === cleanValue.toLowerCase())
    ) {
      result.push(cleanValue);
    }
  });

  return result;
};

export const buildFormattedAddress = (profile: Profile) =>
  [profile.address, profile.city, profile.state, profile.zipCode, profile.country]
    .filter(Boolean)
    .join(", ") || "Brasil";

export const extractGoalKeywords = (iaDescription: string) => {
  const explicitTerms = iaDescription
    .split(/[,;\n]/)
    .map((term) => term.trim())
    .filter((term) => term.length > 2);

  if (explicitTerms.length > 1) return unique(explicitTerms);

  const quotedTerms = Array.from(
    iaDescription.matchAll(/["'“”]([^"'“”]{3,})["'“”]/g),
  ).map((match) => match[1].trim());

  return quotedTerms.length > 0 ? unique(quotedTerms) : [];
};

export const buildAdvisorCategories = (
  profile: Profile,
  iaDescription: string,
  suggestedCategories: string[] = [],
) => {
  const currentCategories = [
    profile.category,
    ...(profile.secondaryCategories || []),
    ...suggestedCategories,
  ].filter(Boolean);

  if (currentCategories.length > 0) {
    return unique(currentCategories);
  }

  return extractGoalKeywords(iaDescription);
};

export const buildAdvisorKeywords = ({
  suggestedKeywords,
  iaDescription,
  gabaritoPostKeywords,
  gabaritoCommentKeywords,
}: {
  suggestedKeywords: string[];
  iaDescription: string;
  gabaritoPostKeywords: string;
  gabaritoCommentKeywords: string;
}) =>
  unique([
    ...suggestedKeywords,
    ...splitKeywords(gabaritoPostKeywords),
    ...splitKeywords(gabaritoCommentKeywords),
    ...extractGoalKeywords(iaDescription),
  ]);
